(function () {
  document.querySelectorAll('[data-doctor-stage]').forEach(function (stage) {
    if (stage.__conciergeApplyDoctorsInit) return;
    stage.__conciergeApplyDoctorsInit = true;

    var panels = Array.prototype.slice.call(stage.querySelectorAll('[data-doctor-panel]'));
    var count = panels.length;
    if (!count) return;

    var statsCollapseMq = window.matchMedia('(max-width: 767px)');
    var statsToggles = Array.prototype.slice.call(stage.querySelectorAll('[data-doctor-stats-toggle]'));
    var statsWasCollapsible = null;

    function syncStatsDisclosure() {
      var canCollapse = statsCollapseMq.matches;
      statsToggles.forEach(function (toggle) {
        if (canCollapse) {
          toggle.disabled = false;
          if (statsWasCollapsible !== true) {
            toggle.setAttribute('aria-expanded', 'false');
          }
        } else {
          toggle.disabled = true;
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      statsWasCollapsible = canCollapse;
    }

    function setActive(index) {
      index = ((index % count) + count) % count;
      var activePanel = null;
      panels.forEach(function (panel) {
        var isActive = parseInt(panel.getAttribute('data-doctor-panel'), 10) === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) activePanel = panel;
      });
      stage.querySelectorAll('[data-doctor-dot]').forEach(function (dot) {
        var isActive = parseInt(dot.getAttribute('data-doctor-dot'), 10) === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (!activePanel) return;
      var heading = activePanel.querySelector('.concierge-apply-doctors__heading');
      if (!heading) return;
      requestAnimationFrame(function () {
        heading.focus();
      });
    }

    function currentIndex() {
      var active = panels.filter(function (panel) {
        return panel.classList.contains('is-active');
      })[0];
      return active ? parseInt(active.getAttribute('data-doctor-panel'), 10) : 0;
    }

    stage.addEventListener('click', function (event) {
      var goto = event.target.closest('[data-doctor-goto]');
      var prev = event.target.closest('[data-doctor-prev]');
      var next = event.target.closest('[data-doctor-next]');
      var dot = event.target.closest('[data-doctor-dot]');
      var statsToggle = event.target.closest('[data-doctor-stats-toggle]');
      var readMore = event.target.closest('[data-doctor-read-more]');

      if (goto) {
        setActive(parseInt(goto.getAttribute('data-doctor-goto'), 10));
      } else if (prev) {
        setActive(currentIndex() - 1);
      } else if (next) {
        setActive(currentIndex() + 1);
      } else if (dot) {
        setActive(parseInt(dot.getAttribute('data-doctor-dot'), 10));
      } else if (statsToggle) {
        if (statsToggle.disabled || !statsCollapseMq.matches) return;
        var statsExpanded = statsToggle.getAttribute('aria-expanded') === 'true';
        statsToggle.setAttribute('aria-expanded', String(!statsExpanded));
      } else if (readMore) {
        var bioExpanded = readMore.getAttribute('aria-expanded') === 'true';
        readMore.setAttribute('aria-expanded', String(!bioExpanded));
        var copy = readMore.previousElementSibling;
        if (copy) copy.classList.toggle('is-expanded', !bioExpanded);
        readMore.textContent = bioExpanded ? 'Read more' : 'Read less';
      }
    });

    syncStatsDisclosure();
    if (typeof statsCollapseMq.addEventListener === 'function') {
      statsCollapseMq.addEventListener('change', syncStatsDisclosure);
    } else if (typeof statsCollapseMq.addListener === 'function') {
      statsCollapseMq.addListener(syncStatsDisclosure);
    }
  });
})();
